<template>
  <v-navigation-drawer v-model="drawer_" app clipped>
    <v-list>
      <v-list-group
        v-for="item in groups"
        :key="item.name"
        v-model="item.active"
        prepend-icon="mdi-newspaper"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item v-for="child in item.items" :key="child.title" :to="{ name: child.route }">
          <v-list-item-content>
            <v-list-item-title v-text="child.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'Drawer',
  props: {
    drawer: { type: Boolean, default: false },
    mini: { type: Boolean, default: false },
  },
  data() {
    return {
      drawer_: this.drawer,
      mini_: this.mini,
    }
  },
  computed: {
    tasksItems() {
      const taskItems = [
        {
          route: 'activist',
          icon: '',
          title: 'Задания',
          has_access: this.isSuperuser,
        },
        {
          route: 'activist_metrics',
          icon: '',
          title: 'Метрики',
          has_access: this.isSuperuser,
        },
      ]
      return taskItems.filter((x) => x.has_access)
    },
    hpsItems() {
      const hpsItems = [
        {
          route: 'hps_contacts',
          icon: '',
          title: 'Контакты',
          has_access: this.isSuperuser || this.isHPS,
        },
        {
          route: 'hps_about',
          icon: '',
          title: 'О нас',
          has_access: this.isSuperuser || this.isHPS,
        },
        {
          route: 'hps_courses',
          icon: '',
          title: 'Курсы',
          has_access: this.isSuperuser || this.isHPS,
        },
      ]
      return hpsItems.filter((x) => x.has_access)
    },
    regionItems() {
      const regionItems = [
        { route: 'faq', icon: 'mdi-newspaper', title: 'Инструкции', has_access: true },
        { route: 'articles', icon: 'mdi-newspaper', title: 'Статьи', has_access: true },
        {
          route: 'press',
          icon: 'mdi-book-open-variant',
          title: 'Пресса',
          has_access: true,
        },
        {
          route: 'photo_albums_list',
          icon: 'mdi-folder-multiple-image',
          title: 'Альбомы',
          has_access: true,
        },
        {
          route: 'members_list',
          icon: 'mdi-account-multiple',
          title: 'Лица',
          has_access: true,
        },
        { route: 'sites', icon: 'mdi-earth', title: 'Контакты', has_access: true },
        {
          route: 'party',
          icon: '',
          title: 'Партия',
          has_access: this.isSuperuser || this.isEditor,
        },
        {
          route: 'documents',
          icon: 'mdi-file-document',
          title: 'Документы',
          has_access: true,
        },
        {
          route: 'playlist',
          icon: 'mdi-file-document',
          title: 'Плейлисты',
          has_access: true,
        },
        {
          route: 'metrika',
          icon: 'mdi-chart-areaspline',
          title: 'Метрики',
          has_access: true,
        },
      ]
      return regionItems.filter((x) => x.has_access)
    },
    yasLDPRItems() {
      const items = [
        {
          route: 'yasldpr',
          icon: '',
          title: 'Фото',
          has_access:
            this.isSuperuser || this.isEditor || this.isYasLDPREditor || this.isRO || this.isROSMM,
        },
      ]
      return items.filter((x) => x.has_access)
    },
    vstupiItems() {
      const items = [
        {
          route: 'vstupi',
          icon: '',
          title: 'Проверка телефона',
          has_access: this.isSuperuser || this.isEditor || this.isVstupiOperator,
        },
      ]
      return items.filter((x) => x.has_access)
    },
    superuserItems() {
      const superuserItems = [
        { route: 'users', icon: '', title: 'Пользователи', has_access: this.isSuperuser },
        {
          route: 'references-events',
          icon: '',
          title: 'Таблица по мероприятиям',
          has_access: this.isSuperuser,
        },
        {
          route: 'references-courses',
          icon: '',
          title: 'Таблица по ВПШ',
          has_access: this.isSuperuser,
        },
        {
          route: 'references-sites-posts',
          icon: '',
          title: 'Таблица постов на сайтах',
          has_access: this.isSuperuser,
        },
        {
          route: 'notifications',
          icon: '',
          title: 'Отправка уведомлений',
          has_access: this.isSuperuser,
        },
        {
          route: 'integrations',
          icon: '',
          title: 'Интеграции',
          has_access: this.isSuperuser,
        },
      ]
      return superuserItems.filter((x) => x.has_access)
    },
    groups() {
      const groups = [
        {
          title: 'Регион контент',
          items: this.regionItems,
          active: false,
          if: this.hasRegionContentScopeAccess,
        },
        {
          title: 'Активист',
          items: this.tasksItems,
          active: false,
          if: this.hasActivistScopeAccess,
        },
        { title: 'ВПШ контент', items: this.hpsItems, active: false, if: this.isHPS },
        {
          title: 'Суперпользователь',
          items: this.superuserItems,
          active: false,
          if: this.isSuperuser,
        },
        {
          title: 'Я с ЛДПР',
          items: this.yasLDPRItems,
          active: false,
          if:
            this.isSuperuser || this.isEditor || this.isYasLDPREditor || this.isRO || this.isROSMM,
        },
        {
          title: '35 лет ЛДПР',
          items: this.vstupiItems,
          active: false,
          if: this.isVstupiOperator,
        },
      ]
      return groups.filter((x) => {
        return x.if
      })
    },
  },
  watch: {
    drawer() {
      this.drawer_ = this.drawer
    },
    drawer_() {
      this.$emit('update:drawer', this.drawer_)
    },
  },
  methods: {
    hasAccess(x) {
      return !!x
    },
  },
}
</script>
